import { createAccessControl } from "better-auth/plugins/access";
import { adminAc, defaultStatements, ownerAc } from "better-auth/plugins/organization/access";
import {
  roleHasResolvedPermission,
  type OrgRolePermissions,
} from "../permission-catalog";

const statement = {
  ...defaultStatements,
  review: ["create", "read", "update", "delete", "share", "regenerate"],
  contractType: ["create", "read", "update", "delete"],
  customRole: ["create", "read", "update", "delete"],
  app: ["contract-review", "chat", "drafting", "regulatory", "rag", "research"],
} as const;

export const ac = createAccessControl(statement);

export const owner = ac.newRole({
  review: ["create", "read", "update", "delete", "share", "regenerate"],
  contractType: ["create", "read", "update", "delete"],
  customRole: ["create", "read", "update", "delete"],
  app: ["contract-review", "chat", "drafting", "regulatory", "rag", "research"],
  ...ownerAc.statements,
});

export const admin = ac.newRole({
  review: ["create", "read", "update", "delete", "share", "regenerate"],
  contractType: ["create", "read", "update", "delete"],
  customRole: ["create", "read", "update", "delete"],
  app: ["contract-review", "chat", "drafting", "regulatory", "rag", "research"],
  ...ownerAc.statements,
});

export const manager = ac.newRole({
  review: ["create", "read", "update", "delete", "share", "regenerate"],
  contractType: ["create", "read", "update", "delete"],
  customRole: ["create", "read", "update", "delete"],
  app: ["contract-review", "chat", "rag"],
  ...adminAc.statements,
});

export const member = ac.newRole({
  review: ["create", "read", "update", "share"],
  contractType: ["read"],
  customRole: ["read"],
  app: ["contract-review", "chat", "rag"],
});

export const viewer = ac.newRole({
  review: ["read"],
  contractType: ["read"],
  customRole: ["read"],
  app: ["contract-review", "chat", "rag"],
});

export const orgRoles = { owner, admin, manager, member, viewer } as const;

export const ORG_ROLE_NAMES = ["owner", "admin", "manager", "member", "viewer"] as const;
export type OrgRoleName = (typeof ORG_ROLE_NAMES)[number];

export type { OrgRolePermissions } from "../permission-catalog";

export function roleHasPermission(
  orgRole: string | null | undefined,
  resource: keyof typeof statement,
  action: string,
  orgRolePermissions?: OrgRolePermissions | null
): boolean {
  if (orgRolePermissions) {
    return roleHasResolvedPermission(orgRole, resource, action, orgRolePermissions);
  }
  if (!orgRole) return false;
  const role = orgRoles[orgRole as OrgRoleName];
  if (!role) return false;
  const permissions = role.statements[resource as keyof typeof role.statements];
  if (!permissions) return false;
  return (permissions as readonly string[]).includes(action);
}
